export default {
  applicationSettings: "ApplicationSettingsSection",
  documentSettings: "DocumentSettingsSection",
  worktagFieldsSettings: "WorktagFieldsSettingsSection"
};
